module.exports = __webpack_public_path__ + "Icono_StatusMenu_126px.png";